const UNIDADES = ['', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove'];
const DEZ_A_DEZENOVE = ['dez', 'onze', 'doze', 'treze', 'catorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove'];
const DEZENAS = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];
const CENTENAS = ['', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos', 'seiscentos', 'setecentos', 'oitocentos', 'novecentos'];

const GRUPOS: Array<{ singular: string; plural: string }> = [
    { singular: '', plural: '' },
    { singular: 'mil', plural: 'mil' },
    { singular: 'milhão', plural: 'milhões' },
    { singular: 'bilhão', plural: 'bilhões' },
];

/**
 * Conversão de valores monetários (Real) para texto por extenso em português, usada em recibos/documentos
 * fiscais. Não existe utilitário equivalente pronto no projeto — algoritmo padrão de extenso numérico.
 */
export class ValorPorExtensoUtil {
    public static converter(valor: number): string {
        const valorAbsoluto = Math.abs(Math.round(valor * 100)) / 100;
        const parteInteira = Math.floor(valorAbsoluto);
        const centavos = Math.round((valorAbsoluto - parteInteira) * 100);

        const textoReais = parteInteira === 0 ? 'zero reais' : `${this.grupoPorExtenso(parteInteira)} ${parteInteira === 1 ? 'real' : 'reais'}`;

        if (centavos === 0) {
            return this.capitalizar(textoReais);
        }

        const textoCentavos = `${this.grupoPorExtenso(centavos)} ${centavos === 1 ? 'centavo' : 'centavos'}`;
        return this.capitalizar(`${textoReais} e ${textoCentavos}`);
    }

    private static grupoPorExtenso(numero: number): string {
        if (numero === 0) return 'zero';

        const grupos: number[] = [];
        let restante = numero;
        while (restante > 0) {
            grupos.unshift(restante % 1000);
            restante = Math.floor(restante / 1000);
        }

        const partes: string[] = [];
        const totalGrupos = grupos.length;

        grupos.forEach((grupo, index) => {
            if (grupo === 0) return;
            const ordem = totalGrupos - 1 - index;
            const textoCentena = this.centenaPorExtenso(grupo);

            if (ordem === 0) {
                partes.push(textoCentena);
            } else {
                const nomeGrupo = grupo === 1 ? GRUPOS[ordem].singular : GRUPOS[ordem].plural;
                partes.push(grupo === 1 && ordem === 1 ? nomeGrupo : `${textoCentena} ${nomeGrupo}`);
            }
        });

        if (partes.length === 1) return partes[0];

        const ultima = partes[partes.length - 1];
        const inicio = partes.slice(0, -1).join(', ');
        return `${inicio} e ${ultima}`;
    }

    private static centenaPorExtenso(numero: number): string {
        if (numero === 100) return 'cem';

        const centena = Math.floor(numero / 100);
        const resto = numero % 100;
        const partes: string[] = [];

        if (centena > 0) partes.push(CENTENAS[centena]);
        if (resto > 0) partes.push(this.dezenaPorExtenso(resto));

        return partes.join(' e ');
    }

    private static dezenaPorExtenso(numero: number): string {
        if (numero < 10) return UNIDADES[numero];
        if (numero < 20) return DEZ_A_DEZENOVE[numero - 10];

        const dezena = Math.floor(numero / 10);
        const unidade = numero % 10;
        return unidade > 0 ? `${DEZENAS[dezena]} e ${UNIDADES[unidade]}` : DEZENAS[dezena];
    }

    private static capitalizar(texto: string): string {
        return texto.charAt(0).toUpperCase() + texto.slice(1);
    }
}
